

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import {
    partnersRewardStatuses,
    partnersTransferKinds
} from '../statuses';

export default class PartnersRewardsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'partners-rewards';
        this.Server = this.props.context.getState().server.partnersRewards;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'resourceUuid'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'inviterId',
                label: 'inviter',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'inviter',
                show: 'email'
            },
            {
                id: 'inviteeId',
                label: 'invitee',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'invitee',
                show: 'email'
            },
            {
                id: 'transferKind',
                label: 'transferKind',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(partnersTransferKinds)
            },
            {
                id: 'resourceUuid',
                label: 'resourceUuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'rewardAmount',
                label: 'rewardAmount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'currencyId',
                label: 'currency',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'currencies',
                object: 'currency',
                show: 'name'
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(partnersRewardStatuses)
            },
            {
                id: 'dateAvailable',
                label: 'dateAvailable',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'payoutId',
                label: 'payout',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'partnersPayouts',
                object: 'payout',
                show: 'uuid'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}